export default __webpack_public_path__ + "static/media/francorp-logo.213b3ff5.png";